module.exports = __webpack_public_path__ + "img/modern_shop_thumbnail-600x450.9d396ca7.jpg";